module.exports = __webpack_public_path__ + "img/titleen.bcf38821.png";